export default {
  // baseUrl: "http://naf-backend.test/api",
  baseUrl: 'https://api.nafaftersales.com/api/',
};